/*
 *  Copyright (c) 2019 Cognitran Limited. All Rights Reserved.
 */

var oldSetupTemplates = Selectize.prototype.setupTemplates;
Selectize.prototype.setupTemplates = function () {
    var self = this;
    oldSetupTemplates.apply(self);
    self.settings.render.option_create = function (data, escape) {
        return '<div class="create">' + $i.i18n.get('selectize.add.option.label' , escape(data.input)) + '</div>';
    };
};